import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetEmployeesPayload } from './get-employees.payload';

export async function getDefaultEmployeeFilters(): Promise<GetEmployeesPayload> {
  const [error, res] = await tryCatch(HSApi.get<GetEmployeesPayload>(`/employee-filter`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
